import { render } from "./consuleTwo.vue?vue&type=template&id=6a480e3b&scoped=true"
import script from "./consuleTwo.vue?vue&type=script&lang=js"
export * from "./consuleTwo.vue?vue&type=script&lang=js"

import "./consuleTwo.vue?vue&type=style&index=0&id=6a480e3b&lang=scss&scoped=true"

import exportComponent from "/Users/wanggaochao/项目/善城 (2)/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a480e3b"]])

export default __exports__